import React, { Fragment } from 'react';
import cn from 'classnames';
import { includes } from 'lodash';

import { AVAILABLE_ROUTES_WITH_PARENT_ROUTE } from 'app-constants';
import { NavButton } from 'components';
import UserDevice from 'services/user-device';
import type { ListNavTab } from 'types';
import { extractParentRouteFromHistory, removeLastSlash } from 'utils';

import './ListNav.scss';

interface Props {
    tabs: ListNavTab[];
}

const ListNav: React.FC<Props> = ({ tabs }) => {
    const parentRoute = extractParentRouteFromHistory();

    return (
        <div
            styleName={cn('container', {
                'is-mobile': UserDevice.getInstance()?.isDeviceMobile(),
            })}
            className="__app-ListNav__container"
        >
            {tabs.map(
                ({ link, title, isDisable, isCreateButton = true }, idx) => {
                    const key = link + idx;

                    return isCreateButton ? (
                        <div
                            styleName="button"
                            className="__app-ListNav-button"
                            // NOTE: tabs have not uniq field, tabs not change
                            key={key}
                        >
                            <NavButton
                                link={
                                    includes(
                                        AVAILABLE_ROUTES_WITH_PARENT_ROUTE,
                                        link
                                    )
                                        ? removeLastSlash(
                                              `${parentRoute}${link}`
                                          )
                                        : link
                                }
                                isDisable={!!isDisable}
                            >
                                {title}
                            </NavButton>
                        </div>
                    ) : (
                        <Fragment key={key}>{title}</Fragment>
                    );
                }
            )}
        </div>
    );
};

export default ListNav;
